package one.healthium.carnivore.presentation.navigation.today

import androidx.compose.runtime.Composable
import one.healthium.today.ui.carni.TodayScreen

@Composable
fun TodayContent(
    component: TodayComponent,
) {
    TodayScreen(component)
}